import React, {useEffect, useState} from 'react';
import Product from "./Product";
import axios from "axios";

export function Assortment({type, collection, maxPrice, minPrice, offset, count, excludeId, limit, sortBy})
{
  const [products, setProducts] = useState([])
  const [error, setError] = useState(null)

  useEffect(() => {
    let params = {};
    if (!excludeId) {
      params = {type, collection, minPrice, maxPrice, offset, count};
      Object.keys(params).forEach(k => { if (params[k] === undefined || params[k] === null) delete params[k] });
    }
    axios.get("product/", {params}).then((result) => {
      if (result.status < 300) {
        setProducts(result.data);
      }
    }).catch(() => setError('Ошибка загрузки'));
  }, [type, collection, maxPrice, minPrice, excludeId]);

  if (error) return null;

  let result = products;

  if (excludeId) {
    const score = (p) => {
      let s = 0;
      if (collection && p.collection === collection && type && p.type === type) s = 3;
      else if (collection && p.collection === collection) s = 2;
      else if (type && p.type === type) s = 1;
      return s;
    };
    result = result
      .filter(p => p.id !== excludeId)
      .sort((a, b) => {
        const sa = score(a), sb = score(b);
        if (sa !== sb) return sb - sa;
        return (a.calculatedPrice || 0) - (b.calculatedPrice || 0);
      });
  }

  if (limit) {
    result = result.slice(0, limit);
  }

  if (sortBy && sortBy !== 'default') {
    result = [...result].sort((a, b) => {
      if (sortBy === 'price-asc') return (a.calculatedPrice || 0) - (b.calculatedPrice || 0);
      if (sortBy === 'price-desc') return (b.calculatedPrice || 0) - (a.calculatedPrice || 0);
      if (sortBy === 'name') return (a.name || '').localeCompare(b.name || '');
      return 0;
    });
  }

  if (result.length > 0) {
    return (<div className="product-grid">
      {result.map(it => <Product key={it.id} product={it} />)}
    </div>);
  }
  return null;
}
